import React, { memo, useCallback, useState } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import { SvgBlackTrash, SvgUpdateAssignationIcon, SvgMenuExpenses } from "@routes/IconeSvg";
import { previewDate } from "@helpers/_functions";
import calendar_carrer from "@assets/image/icones/carrer/calendar_carrer.svg";
import { certificationsItems } from "@routes/IconeSvg";
import file_carrer from "@assets/image/icones/carrer/file_carrer.svg";
import notif_certification from "@assets/image/icones/carrer/notif_certification.svg";
import {
  ModalAddOrUpdateCertification as ModalUpdateCertifications,
  ModalDeleteCertification
} from "./modals";
import { Menu } from "@components/tailwindComponents";
import SharedViewFile from "@components/modals/SharedViewFile";
import { useTranslation } from "react-i18next";

const BlackTooltip = withStyles(() => ({
  tooltip: {
    maxWidth: "200px",
    backgroundColor: "#3F3F51",
    fontFamily: "Poppins_Medium",
    fontSize: "13px",
    padding: "8px 17px"
  }
}))(Tooltip);

const CertificationListItem = ({ certification, idEmployer, isReadOnly, isEnterprisePage, userConnected }) => {
  const { t, i18n } = useTranslation("pages.employés.parcours&Certifications");
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [sharedViewFile, setShowFile] = useState(false);
  const [file, setFile] = useState({});

  const toggleModalUpdate = useCallback(
    () => setIsOpenUpdate((_isOpenUpdate) => !_isOpenUpdate),
    []
  );
  const toggleModalDelete = useCallback(
    () => setIsOpenDelete((_isOpenDelete) => !_isOpenDelete),
    []
  );
  const listsMenu = [

    {
      icon: <SvgBlackTrash />,
      title: "Effacer",
      click: () => toggleModalDelete()
    },
    {
      icon: <SvgUpdateAssignationIcon />,
      title: "Modifier",
      click: () => toggleModalUpdate()
    }
  ]
  const onClickShowFile = (file) => {
    setShowFile(!sharedViewFile);
    setFile(file);
  };

  const alertDateStr = React.useMemo(
    () => previewDate(certification.alertDate, i18n),
    [certification.alertDate, i18n.language]
  );

  return (
    <>
      <tr className="arh-border arh-border-solid arh-border-x-0 arh-border-t-0 arh-border-b arh-border-borderTable hover:arh-bg-greyColor">
        <td className="arh-p-2 arh-font-medium">
          <div className="arh-max-w-full arh-flex arh-items-center arh-space-x-2.5">
            {certificationsItems()}
            <p className="arh-mb-0 arh-w-full arh-shrink arh-truncate desktop-middle:arh-w-24 arh-max-w-[12rem] arh-font-medium arh-text-xs arh-text-darkGreyColor">
              {certification.title}
            </p>
          </div>
        </td>

        <td className="arh-p-2">
          <div className="arh-flex arh-items-center arh-space-x-2.5">
            <img alt="calendar_carrer" src={calendar_carrer} />
            <span className="arh-font-medium arh-text-xs arh-text-darkGreyColor">
              {previewDate(certification.obtainedDate, i18n)}
            </span>
          </div>
        </td>
        <td className="arh-p-2">
          <div className="arh-flex arh-items-center arh-space-x-2.5">
            {certification.endValidityDate ? (
              <>
                <img alt="calendar_carrer" src={calendar_carrer} />
                <span className="arh-font-medium arh-text-xs arh-text-darkGreyColor">
                  {previewDate(certification.endValidityDate, i18n)}
                </span>
              </>
            ) : (
              "-"
            )}
          </div>
        </td>

        <td className="arh-p-2">
          {certification.note ? (
            <BlackTooltip
              placement="top"
              title={
                <p
                  className="arh-m-0 arh-w-full"
                  style={{
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 5,
                    fontSize: "12px"
                  }}
                >
                  {certification.note}
                </p>
              }
            >
              <img alt="file_carrer" src={file_carrer} />
            </BlackTooltip>
          ) : (
            "-"
          )}
        </td>

        {/* <td className="arh-p-2 arh-font-medium arh-text-xs arh-text-darkGreyColor">
          {certification.file?.length || "-"}
        </td> */}
        <td className="arh-p-2 arh-font-medium arh-text-xs arh-text-darkGreyColor">
          {certification?.file?.length > 0
            ? certification?.file?.map((file) => (
              <BlackTooltip
                title={file?.filename}
                placement="top"
                key={file?._id}
              >
                <div
                  className="arh-flex arh-items-center arh-justify-start arh-space-x-2 arh-cursor-pointer"
                  onClick={() => onClickShowFile(file)}
                >
                  <span>{SvgMenuExpenses()}</span>
                  <span className="arh-truncate arh-w-full arh-block">
                    {file?.filename}
                  </span>
                </div>
              </BlackTooltip>
            ))
            : "-"}
        </td>

        <td className="arh-p-2">
          <div className="arh-flex arh-items-center arh-space-x-3">
            {alertDateStr === "-" ? (
              "-"
            ) : (
              <>
                <img alt="file_carrer" src={notif_certification} />
                <span className="arh-font-medium arh-text-xs arh-text-darkGreyColor">
                  {alertDateStr}
                </span>
              </>
            )}
          </div>
        </td>
        <td className="arh-p-2">
          {!isReadOnly && (
            <Menu
              lists={listsMenu}
              withIcon
            />
            )
          }
        </td>
      </tr>

      <ModalUpdateCertifications
        isOpen={isOpenUpdate}
        idEmployer={idEmployer}
        certification={certification}
        onClickClose={toggleModalUpdate}
        isEnterprisePage={isEnterprisePage}
        userConnected={userConnected}
      />

      <ModalDeleteCertification
        isOpen={isOpenDelete}
        idCertification={certification._id}
        onClickClose={toggleModalDelete}
      />
      <SharedViewFile
        onClickClose={onClickShowFile}
        show={sharedViewFile}
        file={file}
        t={t}
      />
    </>
  );
};

export default memo(CertificationListItem);
